export const LINT = 1;
export const ELEVATION_ZINDEX = 1;
